import React, { Component } from "react";
import { logoutUser } from "../../../actions/authActions";
import { connect } from "react-redux";
import {
  Menu,
  Icon,
  Drawer,
  Tabs,
  Table,
  Input,
  Button,
  Popconfirm,
  Form
} from "antd";
import styled from "styled-components";

const SubMenu = Menu.SubMenu;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const EditableContext = React.createContext();

const CustomButton = styled(Button)`
  && {
    margin: 15px auto;
    color: #fff;
    border: none;
    border-radius: 6px;
    width: 100px;
    left: 50%;
    transform: translate(-50%);
    background ${props => props.background};

    :active,
    :focus,
    :hover {
      background: ${props => props.background};
      color: #fff;
      border: none;
      opacity: 0.7
    }
  }
`;

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends Component {
  state = {
    editing: false
  };

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  handleClickOutside = e => {
    const { editing } = this.state;
    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  };

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;
    return (
      <td ref={node => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {form => {
              this.form = form;
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    rules: [
                      {
                        required: true,
                        message: `${title} is required.`
                      }
                    ],
                    initialValue: record[dataIndex]
                  })(
                    <Input
                      ref={node => (this.input = node)}
                      onPressEnter={this.save}
                    />
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{ paddingRight: 24 }}
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        title: "NOGA ID #",
        dataIndex: "nogaID",
        width: "30%",
        editable: true
      },
      {
        title: "",
        dataIndex: "operation",
        render: (text, record) =>
          this.state.dataSource.length >= 1 ? (
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => this.handleDelete(record.key)}
            >
              <a href="javascript:;">Delete</a>
            </Popconfirm>
          ) : null
      }
    ];

    this.state = {
      visible: false,
      dataSource: [
        {
          key: 1,
          nogaID: "212-19"
        }
      ],
      count: 2
    };
  }

  handleClick = ({ key }) => {
    if (key === "logout") {
      this.props.logoutUser();
    } else if (key === "settings") {
      this.showDrawer();
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  handleDelete = key => {
    const dataSource = [...this.state.dataSource];
    this.setState({ dataSource: dataSource.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, dataSource } = this.state;
    const newData = {
      key: count,
      nogaID: `Enter new NOGA ID`
    };
    this.setState({
      dataSource: [...dataSource, newData],
      count: count + 1
    });
  };

  handleSave = row => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ dataSource: newData });
  };

  handleSubmit = e => {
    e.preventDefault();

    console.log(this.state.dataSource);
  };

  render() {
    const { visible, dataSource } = this.state;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell
      }
    };
    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });

    return (
      <div>
        <Menu
          defaultSelectedKeys={["home"]}
          theme="dark"
          onClick={this.handleClick}
          mode="horizontal"
        >
          <Menu.Item key="home">
            <Icon type="home" />
            Home
          </Menu.Item>
          {/* <Menu.Item key="settings" style={{ float: "right" }}>
            <Icon type="setting" />
            Settings
          </Menu.Item> */}
          <SubMenu
            style={{ float: "right" }}
            title={
              <span className="submenu-title-wrapper">
                <Icon type="user" />
                {this.props.auth.isAuthenticated
                  ? this.props.auth.user.userProfile.title
                  : ""}
              </span>
            }
          >
            <Menu.Item key="logout">Logout</Menu.Item>
          </SubMenu>
        </Menu>
        <Drawer
          title="Settings"
          width={450}
          onClose={this.onClose}
          visible={false}
          style={{
            overflow: "auto",
            height: "calc(100%-108px)",
            paddingBottom: "108px"
          }}
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="NOGA ID" key="1">
              <p style={{ textAlign: "center", fontStyle: "italic" }}>
                Select a NOGA ID # below to edit or delete. Or select 'Add new'
                to a create a new one. Clicked 'Save' when completely finished.
              </p>
              <CustomButton
                background="#00b894"
                type="primary"
                onClick={this.handleAdd}
              >
                Add new
              </CustomButton>
              <Table
                components={components}
                rowClassName={() => "editable-row"}
                bordered={false}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
              <CustomButton
                background="#0984e3"
                onClick={this.handleSubmit}
                type="primary"
              >
                Save
              </CustomButton>
            </TabPane>
          </Tabs>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { logoutUser }
)(Navigation);
